import {Coordinate} from "ol/coordinate";

export enum UserEnum {
  RIDER  = "RIDER",
  SELLER = "SELLER",
  STAFF  = "STAFF",
  ADMIN  = "ADMIN"
}

export enum BunnyEnum {
  FLEX  = "FLEX",
  STAFF = "STAFF",
  FIXED = "FIXED",
}

export enum ContainerEnum {
  BLACK   = "BLACK",
  BLUE    = "BLUE",
  WHITE   = "WHITE",
  OFFROAD = "OFFROAD",
  RAINBOW = "RAINBOW",
  YELLOW  = "YELLOW",
  ORANGE  = "ORANGE",
}

export type GetListResponse<T = any> = {
  count: number;
  next: string;
  previous: string;
  current_page: number;
  items_per_page: number;
  results: T[];
};

export type GetListParams = {
  page?: number;
  page_size?: number;
};

type TErrorToast = {
  [key: string]: {
    "detail": {
      "toast": string,
      "code": string[]
    }
  }
}

type TErrorItem = {
  code: string;
  field: "toast" | "ui.title" | "ui.text" | "ui.button.ok" | "ui.button.cancel";
  message: string | {
    message: string
  };
} | TErrorToast

export type TApiError = {
  errors?: TErrorItem[],
  message?: string;
  detail?: string;
};

export type TShippingTooltip<T> = {
  shippings?: T[];
  position?: Coordinate;
};
